import React from 'react';
import LoadingSpinnerApc from 'chameleon/packages/blue-book-player/library/LoadingSpinner';
const LoadingSpinner = () => (
  <div className="fixed flex items-center justify-center bg-bluebook-dark-gray w-full h-full top-0 left-0 z-overPage">
    <LoadingSpinnerApc containerClassName="" />
  </div>
);

export default LoadingSpinner;
